export { ChartBarSquare as default } from './ChartBarSquare';
